import { useEffect, useRef } from 'react'
import { useTimerStore } from '@/shared/stores/timerStore'
import { timerService } from '@/shared/services/timerService'

const AUTO_SAVE_INTERVAL = 30000 // 30 seconds

export function useTimerAutoSave(): void {
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null)
  const descriptionRef = useRef(useTimerStore.getState().description)
  const elapsedSecondsRef = useRef(useTimerStore.getState().elapsedSeconds)
  const status = useTimerStore(s => s.status)

  // Keep refs current without triggering re-renders
  useEffect(() => {
    const unsub = useTimerStore.subscribe((state) => {
      descriptionRef.current = state.description
      elapsedSecondsRef.current = state.elapsedSeconds
    })
    return unsub
  }, [])
  
  useEffect(() => {
    if (status === 'running') {
      intervalRef.current = setInterval(() => {
        timerService.autoSave(descriptionRef.current, elapsedSecondsRef.current).catch(() => {
          // Silently fail
        })
      }, AUTO_SAVE_INTERVAL)
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
        intervalRef.current = null
      }
    }
    
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  }, [status])
}

export default useTimerAutoSave
